import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=4c731078&scoped=true&"
import script from "./Configurations.vue?vue&type=script&lang=ts&"
export * from "./Configurations.vue?vue&type=script&lang=ts&"
import style0 from "./Configurations.vue?vue&type=style&index=0&id=4c731078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c731078",
  null
  
)

export default component.exports